import { useMutation } from '@tanstack/react-query';

import { MutationFunction, useRequest } from '@frontend/api';

export type Address = {
  address1: string;
  address2?: string;
  city: string;
  state?: {
    abbr: string;
  };
  country: {
    abbr: string;
  };
  postalCode: string;
};

export type AddressWithContact = {
  attention?: string;
  businessName?: string;
  phone?: string;
  phoneExt?: string;
  address: Address;
};

export type ValidateAddressRequestBody = Address;

export type ValidateAddressResponseBody = {
  isValid: boolean;
  candidates: Address[];
};

export const getValidateAddressInformationMutationKey = () => [
  'validateAddressInformation',
];

export const useValidateAddress: MutationFunction<
  ValidateAddressResponseBody,
  ValidateAddressRequestBody
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationKey: getValidateAddressInformationMutationKey(),
    mutationFn: (body) =>
      request('/addresses/validate_information', {
        init: { method: 'POST', body },
      }),
    ...queryOptions,
  });
};
